module.exports = __webpack_public_path__ + "static/media/icon-note.c24aef34.svg";